import axiosClient from "./axiosClient";

export const holidayApi = {
  getMonthHolidays: (params: {
    year: number,
    month: number,
    page_key: string
  }) => {
      const url = `/api/holidays?year=${params.year}&month=${params.month}&page_key=${params.page_key}`;
      return axiosClient.get(url);
  }
};
